import React from "react";
import card1 from "../../assets/images/about/about_opula.jpg";
import card2 from "../../assets/images/about/about_organic.jpg";
import card3 from "../../assets/images/about/about_eloris.jpg";
import opulaLogo from "../../assets/collectionLogo1.png";
import organiqLogo from "../../assets/collectionLogo2.png";
import elorisLogo from "../../assets/collectionLogo3.png";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Link } from "react-router-dom";
export default function Collection() {
  const cards = [
    { img: card2, logo: organiqLogo }, // dark green bg
    { img: card1, logo: opulaLogo }, // dark maroon bg

    { img: card3, logo: elorisLogo }, // dark blue bg
  ];
  return (
    <div className="bg-[#fdf9ed] sm:py-5 py-10 px-0 md:px-10 2xl:px-0 lg:py-28">
      <div className="sm:max-w-full md:max-w-[80%] xl:max-w-[80rem] 3xl:max-w-[90rem] mx-auto">
        <p
          className=" text-[#333333] md:font-light font-lexend sm:text-[14px] text-base xs:text-[12px] md:text-[17px] p-7 lg:p-0 w-full xl:w-[80%]"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          Our luxury collection, <span className="font-semibold">Opula</span>,
          built with premium imported foam, brings home the feel of world-class
          comfort. Our eco-friendly line,
          <span className="font-semibold">Organiq</span> , made with 100%
          certified organic latex, offers nature's support in its purest form.
          And our hybrid mattresses, <span className="font-medium">Eloris</span>
          , strike the perfect balance between memory foam, latex, and
          traditional resilience-crafted for those who want it all.
        </p>
        <div className="grid xl:grid-cols-3 md:mt-10 lg:mt-20 md:gap-8 gap-11 ms-0 grid-cols-1 p-7 lg:p-0">
          {cards.map((card, index) => (
            <div
              key={index}
              className="relative h-auto group overflow-hidden"
              data-aos="fade-up"
              data-aos-delay={100 * (index + 1)}
            >
              <img
                src={card.img}
                alt=""
                className="w-full xs:h-[290px] md:h-full object-cover"
              />

              {/* Overlay */}
              <div className="md:w-full md:h-30 flex items-center justify-left bg-opacity-90">
                <img
                  src={card.logo}
                  alt="logo"
                  className="h-auto xs:w-[200px] sm:w-[230px] object-contain absolute left-0 bottom-0"
                />

                <Link to="/shop" className="bg-[#fdf9ed] absolute xs:w-12 xs:h-12 w-20 h-20 md:h-24 md:w-24 right-0 bottom-0 flex justify-center items-center">
                  <ArrowForwardIosIcon
                    className="transition-transform duration-300 md:text-[40px] text-2xl hover:translate-x-2 cursor-pointer"
                    sx={{  color: "#3b6840" }}
                    fontSize="40px"
                  />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
